import React, { useEffect, useState } from 'react';
import Select from 'react-select';

const CurrencySelector = ({
  setCurrency=()=> {}
}) => {
  const currencyOptions = [
    { 
      value: 'AUD', 
      label: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img 
            src="https://flagcdn.com/w40/au.png" 
            alt="Australia" 
            style={{ width: '24px', height: '16px', marginRight: '10px' }} 
          />
          <span style={{ fontWeight: 'bold' }}>AUD</span>
        </div>
      ),
      name: 'Australian Dollar',
      price: 'aud_price'
    },
    { 
      value: 'USD', 
      label: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img 
            src="https://flagcdn.com/w40/us.png" 
            alt="USA" 
            style={{ width: '24px', height: '16px', marginRight: '10px' }} 
          />
          <span style={{ fontWeight: 'bold' }}>USD</span>
        </div>
      ),
      name: 'US Dollar',
      price: 'usd_price'
    },
    { 
      value: 'CAD', 
      label: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img 
            src="https://flagcdn.com/w40/ca.png" 
            alt="Canada" 
            style={{ width: '24px', height: '16px', marginRight: '10px' }} 
          />
          <span style={{ fontWeight: 'bold' }}>CAD</span>
        </div>
      ),
      name: 'Canadian Dollar',
      price: 'cad_price'
    },
    { 
      value: 'GBP', 
      label: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img 
            src="https://flagcdn.com/w40/gb.png" 
            alt="Great Britain" 
            style={{ width: '24px', height: '16px', marginRight: '10px' }} 
          />
          <span style={{ fontWeight: 'bold' }}>GBP</span>
        </div>
      ),
      name: 'British Pound',
      price: 'gbp_price'
    },
    { 
      value: 'EUR', 
      label: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img 
            src="https://flagcdn.com/w40/eu.png" 
            alt="Europe" 
            style={{ width: '24px', height: '16px', marginRight: '10px' }} 
          />
          <span style={{ fontWeight: 'bold' }}>EUR</span>
        </div>
      ),
      name: 'Euro',
      price: 'eur_price'
    },
    { 
      value: 'NZD', 
      label: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img 
            src="https://flagcdn.com/w40/nz.png" 
            alt="New Zealand" 
            style={{ width: '24px', height: '16px', marginRight: '10px' }} 
          />
          <span style={{ fontWeight: 'bold' }}>NZD</span>
        </div>
      ),
      name: 'New Zealand Dollar',
      price: 'nzd_price'
    },
    { 
      value: 'INR', 
      label: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img 
            src="https://flagcdn.com/w40/in.png" 
            alt="India" 
            style={{ width: '24px', height: '16px', marginRight: '10px' }} 
          />
          <span style={{ fontWeight: 'bold' }}>INR</span>
        </div>
      ),
      name: 'Indian Rupee',
      price: 'inr_price'
    },
  ];

  const [selectedCurrency, setSelectedCurrency] = useState(currencyOptions[0]);


  const handleChange = (selectedOption) => {
    setSelectedCurrency(selectedOption);
    setCurrency(selectedOption.price);
    console.log(`Currency changed to: ${selectedOption.value} (${selectedOption.name})`);
    // You can add your custom handling here
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: 'none',
      boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
      borderRadius: '25px',
      padding: '2px 5px',
      minHeight: '40px',
      cursor: 'pointer',
    }),
    option: (provided, state) => ({
      ...provided,
      display: 'flex',
      alignItems: 'center',
      padding: '10px 15px',
      backgroundColor: state.isSelected ? '#f0f0f0' : 'white',
      color: '#333',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#f5f5f5',
      },
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '10px',
      boxShadow: '0 3px 10px rgba(0,0,0,0.2)',
    }),
    singleValue: (provided) => ({
      ...provided,
      padding: '0',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '2px 8px',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#666',
    }),
  };

  return (
    <div style={{ width: '150px' }}>
      <Select
        value={selectedCurrency}
        onChange={handleChange}
        options={currencyOptions}
        styles={customStyles}
        isSearchable={false}
      />
    </div>
  );
};

export default CurrencySelector;